import React, { useState, useCallback } from 'react';
import { FaUsers, FaWifi, FaExclamationTriangle } from 'react-icons/fa';
import { useChat } from '../../context/ChatContext';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import '../../css/Chat.css';

const ChatRoom = () => {
  const { activeChat, connectionStatus, reconnectWebSocket } = useChat();
  const [newMessageSent, setNewMessageSent] = useState(false);

  // Új üzenet küldés callback
  const handleNewMessage = useCallback(() => {
    setNewMessageSent(prev => !prev); // Toggle a state-et, hogy kiváltsa a useEffect-et
  }, []);

  // Kapcsolat státusz üzenet
  const getConnectionStatusMessage = () => {
    switch (connectionStatus) {
      case 'connecting':
        return { icon: FaWifi, text: 'Csatlakozás...', className: 'connecting' };
      case 'reconnecting':
        return { icon: FaWifi, text: 'Újracsatlakozás...', className: 'reconnecting' };
      case 'disconnected':
        return { icon: FaWifi, text: 'Kapcsolat megszakadt', className: 'disconnected' };
      case 'failed':
        return { icon: FaExclamationTriangle, text: 'Kapcsolat sikertelen', className: 'failed' };
      default:
        return null;
    }
  };

  const connectionInfo = getConnectionStatusMessage();

  // Ha nincs aktív chat
  if (!activeChat) {
    return (
      <div className="chat-room-view">
        <div className="chat-room-placeholder">
          <div className="placeholder-content">
            <FaUsers className="placeholder-icon" />
            <h2>Válassz egy chatet</h2>
            <p>Kattints egy chatra a bal oldali listából a beszélgetés megkezdéséhez</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-room-view">
      {/* Chat fejléc */}
      <div className="chat-room-header">
        <div className="chat-room-info">
          <div className="chat-room-title">
            <FaUsers className="chat-room-icon" />
            <span className="chat-room-name">{activeChat.name}</span>
          </div>
          
          {activeChat.description && (
            <div className="chat-room-description">
              {activeChat.description}
            </div>
          )}

          {activeChat.users && (
            <div className="chat-room-users">
              <span>{activeChat.users.length} résztvevő</span>
            </div>
          )}
        </div>

        {/* Kapcsolat státusz */}
        {connectionInfo && (
          <div className={`connection-status-banner ${connectionInfo.className}`}>
            <connectionInfo.icon className="status-icon" />
            <span>{connectionInfo.text}</span>
            
            {(connectionStatus === 'disconnected' || connectionStatus === 'failed') && (
              <button 
                className="reconnect-btn"
                onClick={reconnectWebSocket}
                title="Újracsatlakozás"
              >
                Újracsatlakozás
              </button>
            )}
          </div>
        )}
      </div>

      {/* Üzenetek lista */}
      <MessageList 
        chatId={activeChat.chat_id} 
        onNewMessage={newMessageSent}
      />

      {/* Üzenet input */}
      <MessageInput 
        chatId={activeChat.chat_id} 
        disabled={connectionStatus !== 'connected'}
        onMessageSent={handleNewMessage}
      />
    </div>
  );
};

export default ChatRoom;
